export default "__VITE_ASSET__90353735__"